import { TileBaseComponent } from '../../tile-base.component';
import { Component, ElementRef, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  Tile,
} from '../../../../../../shared/models/tile';
import {
  TileMinimalElemSetup,
} from '../../../../../../shared/models/tile-template/interfaces';
import { TilesService } from '../../../../../../core/services/tiles.service';
import {TilePollingService} from '../../../../../../core/services/tile-polling.service';
import { ShadeToolsService } from '../../../../../../core/services/shade-tools.service';
import { AlarmsService } from '../../../../../../core/services/alarms.service';
import { TileHistoryService } from '../../../../../../core/services/tile-history.service';
import { SessionService } from '../../../../../../core/services/session.service';
import { PermissionsService } from 'src/core/services/permissions.service';
import { MotiChatService } from 'src/moti/services/moti-chat.service';
import { ViewportIntersectionService } from '../../../../../../core/services/viewport-intersection.service';


@Component({
    selector: 'motn-tile-minimal',
    templateUrl: './tile-minimal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./tile-minimal.component.scss'],
})
export class TileMinimalComponent extends TileBaseComponent implements OnInit, OnDestroy {
  @Input() rawTile: Tile;
  @Input() elemDef: TileMinimalElemSetup;

  constructor(
    protected tilesService: TilesService,
    protected tilePollingService: TilePollingService,
    protected shadeTools: ShadeToolsService,
    protected alarmsService: AlarmsService,
    protected tileHistoryService: TileHistoryService,
    protected permissionsService: PermissionsService,
    protected session: SessionService,
    protected motiChatService: MotiChatService,
    protected elementRef: ElementRef,
    protected viewportService: ViewportIntersectionService,
  ) {
    super(tilesService, tilePollingService, shadeTools, alarmsService, tileHistoryService, permissionsService, session, motiChatService, elementRef, viewportService);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }


  protected onDestroy(): void {
  }

  protected onInit(): void {
  }
}
